import styled from 'styled-components';
import { Link } from "react-router-dom"

export const Container = styled.footer`
  background: #fff;
  padding: 60px 5% 20px;
  border-top: 1px solid #e2e2e2;
  margin-top: 40px;

  @media (max-width: 1000px) {
    padding: 40px 20px 15px;
  }
`;

export const Wrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin: 0 15px 30px;
  flex: 1;
  min-width: 180px;

  @media (max-width: 768px) {
    margin: 0 10px 25px;
    min-width: 140px;
  }

  @media (max-width: 480px) {
    min-width: 100%;
    margin: 0 0 20px;
    text-align: center;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 40px;
  position: relative;

  &:first-child {
    justify-content: center;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #eaeaea;
  }

  @media (max-width: 768px) {
    margin-bottom: 30px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Links = styled(Link)`
  color: #333;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 400;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  text-decoration: none;
  transition: color 0.2s ease, padding-left 0.2s ease;
  display: block;

  &:hover {
    color: #567B95;
    padding-left: 5px;
  }

  @media (max-width: 480px) {
    margin-bottom: 10px;
  }
`;

export const Link2 = styled.a`
  color: #333;
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 12px;
  display: block;
  text-decoration: none;
  transition: color 0.2s ease;
  font-family: 'Helvetica Neue', Arial, sans-serif;

  &:hover {
    color: #567B95;
    cursor: pointer;
  }

  h3 {
    margin: 0 0 5px 0;
    font-size: 16px;
    font-weight: 600;
    color: #121212;
    display: flex;
    align-items: center;
  }
`;

export const Title = styled.p`
  font-size: 16px;
  color: #121212;
  margin-bottom: 20px;
  text-transform: uppercase;
  line-height: 1.2;
  font-weight: 700;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  letter-spacing: 0.5px;
  position: relative;
  padding-bottom: 10px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 30px;
    height: 2px;
    background: #567B95;
  }

  @media (max-width: 480px) {
    text-align: center;
    
    &::after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 15px 0 0;

  li {
    font-size: 13px;
    color: #666;
    padding: 6px 0;
    border-bottom: 1px solid #f0f0f0;
    transition: color 0.2s ease;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      color: #567B95;
      cursor: pointer;
    }
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid #eaeaea;
  padding-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 30px;

  span {
    color: #666;
    font-size: 12px;
    margin: 0 12px 8px;
    position: relative;
    transition: color 0.2s ease;
    cursor: pointer;

    &:not(:last-child)::after {
      content: '•';
      position: absolute;
      right: -15px;
      color: #ccc;
    }

    &:hover {
      color: #567B95;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    
    span {
      margin: 0 8px 8px;
      
      &:not(:last-child)::after {
        right: -12px;
      }
    }
  }

  @media (max-width: 480px) {
    span {
      font-size: 11px;
      margin: 0 6px 6px;
      
      &:not(:last-child)::after {
        right: -10px;
      }
    }
  }
`;

export const LogoContainer = styled.div`
  text-align: center;
  padding: 20px 0;
  
  img {
    max-width: 200px;
    height: auto;
    filter: grayscale(100%);
    opacity: 0.8;
    transition: filter 0.3s ease, opacity 0.3s ease;

    &:hover {
      filter: grayscale(0%);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    img {
      max-width: 160px;
    }
  }
`;

export const SubscribeColumn = styled(Column)`
  border-left: 1px solid #eaeaea;
  padding-left: 30px;
  min-width: 250px;

  @media (max-width: 1024px) {
    border-left: none;
    padding-left: 0;
    border-top: 1px solid #eaeaea;
    padding-top: 30px;
    margin-top: 20px;
    min-width: 100%;
  }
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-right: 10px;
  background: #567B95;
  border-radius: 50%;
  color: white;
  
  svg {
    font-size: 14px;
  }
`;